import { QuizQuestionProps } from "@/pages/quiz/context/types";
import { doctorPrescribeBanner } from "@/assets/images";
import { Button } from "@/pages/quiz/15000/components/Button";

const DoctorPrescribeBanner = ({
  setQuestionAnswer,
}: QuizQuestionProps<boolean>) => {
  return (
    <div className="flex flex-col justify-center">
      <p className="text-4xl mb-6 text-new-design-gray-500 font-medium whitespace-normal break-keep hyphens-none">
        The medications that our licensed weight loss specialists prescribe are
        recommended by Harvard, Mayo Clinic, WebMD & the National Institutes of
        Health.
      </p>

      <img src={doctorPrescribeBanner} alt="SkinnyRx benefits" />

      <Button onClick={() => setQuestionAnswer(true)} />
    </div>
  );
};

export { DoctorPrescribeBanner };
